export default __webpack_public_path__ + "static/media/B2W.07dfb204.png";